import React, { useState } from "react";
import "./NewsEvents.scss";
import { IoMdTime } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import NewsImage from "../../assets/NewsImages/SummerCamp/summer_camp.jpeg";
import AdmissionModal from "../AdmissionComponents/AdmissionModal/AdmissionModal";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NewsEvents = () => {
  const [admissionModal, setAdmissionModal] = useState(false);
  const eventsList = [
    {
      day: "01",
      month: "July",
      title: "Republic Day (commemorative Only)",
      time:"8:00am"
    },
    {
      day: "12",
      month: "July",
      title: "Anell Charity Drive",
      time: "8:00am"
    },
    {
      day: "19",
      month: "July",
      title: "Graduation Ceremony",
      time:"8:00am"
    },
    
  ];
  useEffect(() => {
    if (admissionModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  });
  return (
    <div className="news-events">
      <div className="news-events-header">
        <h1>News & Events</h1>
        <div className="bottom">
          <Link to={"/news-events/news"} className="read-all-news">Read All News</Link>
          <div className="underline"></div>
        </div>
      </div>
      <div className="content">
        <div className="news">
          <div className="news-content">
            <img src={NewsImage} alt="medical screening" />
            <p>2024 ANELL SUMMER CAMP</p>
            <Link to={"/news-events/news/summer-camp"} className="news-caption">
              We are thrilled to introduce the 2024 Anell School of Excellence Summer Camp Program, catering to children aged 2 to 12, both ANELL and non-ANELL.
            </Link>
          </div>
        </div>
        <div className="events">
          <div className="events-content">
            <div className="title">
              <h3>Upcoming Events</h3>
              <div className="bar"></div>
            </div>
            <div className="event-list">
              {eventsList.map((event, index) => (
                <div key={index} className="event-item">
                  <div className="date">
                    <h3 className="day">{event.day}</h3>
                    <h3 className="month">{event.month}</h3>
                    <div className="date-underline"></div>
                  </div>
                  <div className="event-details">
                    <div className="event-title">
                      <h3>{event.title}</h3>
                    </div>
                    <div className="time-venue">
                      <div className="time">
                        <IoMdTime />
                        {event.time}
                      </div>
                      <div className="venue">
                        <FaLocationDot />
                        School Premise
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="admission-apply">
          <div className="admission-content">
            <h2 className="apply-title">We Are Hiring</h2>
            {admissionModal && (
              <AdmissionModal
                admissionModal={admissionModal}
                setAdmissionModal={setAdmissionModal}
              />
            )}
            <Link to="/about/careers"
              className="classic-button"
              // onClick={() => setAdmissionModal(!admissionModal)}
            >
              Apply Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEvents;
